module.exports = __webpack_public_path__ + "static/img/bg-m-0518-top.c90cdff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-m-0518-top.jpg
// module id = ++C2
// module chunks = 1